import React from 'react';
import { GoogleMap, Marker, useJsApiLoader } from '@react-google-maps/api';
const iconPath = require("../../instrument.png")

const GMap = ({instruments, height}) => {

  const singaporeCenter = { lat: 1.3521, lng: 103.8198 };
  const mapContainerStyle = {
    width: '100%',
    height: `${height}`,
  };

  const mapStyles = [
    {
      featureType: 'poi',
      elementType: 'labels',
      stylers: [{ visibility: 'off' }],
    },
    {
      featureType: 'poi',
      elementType: 'labels.icon',
      stylers: [{ visibility: 'off' }],
    },
  ];

  const { isLoaded, loadError } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_API_KEY || '',
    version: 'weekly',
  });

  

  // Define the marker position for Paya Lebar
  // const payaLebarPosition = { lat: 1.3180, lng: 103.8914 };
  // const iconPath = "../../logo.png";
  
  return (
      <div style={{ width: '100%', minHeight: `${height}`, backgroundColor: '#e5e7eb', borderRadius: '4px', overflow: 'hidden' }}>
        {!isLoaded || loadError ? (
          <div style={{ width: '100%', height: `${height}`, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#475569', textAlign: 'center', padding: '16px' }}>
            <div>
              <div style={{ fontWeight: 600, marginBottom: '8px' }}>
                Map preview unavailable
              </div>
              <div style={{ fontSize: '14px' }}>
                The map area keeps this same size so you can check alignment while the Google Maps key is being fixed.
              </div>
            </div>
          </div>
        ) : (
        <GoogleMap
          mapContainerStyle={mapContainerStyle}
          center={singaporeCenter}
          zoom={12}
          options={{ styles: mapStyles }}
        >
          {instruments.map((e) => {
            return <Marker
            key={e.id || `${e.instrument_location_latitude}-${e.instrument_location_longitude}`}
            title={e.instrument_name + "\n" + e.instrument_model + "\n" + e.instrument_brand}
            icon={{
              url: 'https://maps.google.com/mapfiles/ms/icons/red-dot.png',
            }} 
            position={{
              lat: parseFloat(e.instrument_location_latitude),
              lng: parseFloat(e.instrument_location_longitude)
            }}
          >
          </Marker>})}
        </GoogleMap>
        )}
      </div>
  );
};

export default GMap;
